import { memo, useCallback } from 'react'
import SaveButton from 'components/SaveButton'
import FeedIcon from 'components/FeedIcon'
import styles from './FeedViewHeader.pcss'
import { Feed } from 'interfaces/Content'

function FeedViewHeader(props: {
  feed: Feed
  onSourceChange(sourceUrl: string): void
  onSave(feed: Feed): void
}) {
  const { feed, onSave } = props

  const handleSave = useCallback(() => {
    onSave(feed)
  }, [onSave, feed])

  const name = feed.name

  return (
    <header className={styles.header}>
      <SaveButton onClick={handleSave} className={styles['btn-save']} />
      <FeedIcon className={styles.avatar} feed={feed} showTooltip />
      <h2 title={name} className={`${styles.title} text-ellipsis`}>{name}</h2>
    </header>
  )
}

export default memo(FeedViewHeader)
